import MinimalLayout from '../layout/MinimalLayout'
import LoginPage from '../pages/LoginPage'
import PasswordResetPage from '../pages/PasswordResetPage'
import PasswordSentPage from '../pages/PasswordSentPage'
import { PATH_LOGIN } from './constant'
import PasswordCreatePage from '../pages/PasswordCreatePage'

const LoginRoutes = {
  element: <MinimalLayout />,
  children: [
    {
      path: PATH_LOGIN.LOGIN,
      element: <LoginPage />
    },
    {
      path: PATH_LOGIN.PASSWORD_RESET,
      element: <PasswordResetPage />
    },
    {
      path: PATH_LOGIN.PASSWORD_SENT,
      element: <PasswordSentPage />
    },
    {
      path: PATH_LOGIN.PASSWORD_CREATE,
      element: <PasswordCreatePage />
    },
    {
      path: PATH_LOGIN.PASSWORD_WP_RESET,
      element: <PasswordResetPage />
    }
  ]
}

export default LoginRoutes
